module.exports = __webpack_public_path__ + "bb4.no1.1fc4e14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb4.no1.jpg
// module id = sJCv
// module chunks = 0